import { ImageSquare } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const photoSrc = (p, thumb = false) =>
  thumb && p.storage_path
    ? `${API}/photos/${p.storage_path}?w=900&auth=${localStorage.getItem("sw_token")}`
    : `${API}/photos/${p.storage_path}?auth=${localStorage.getItem("sw_token")}`;

export const firstPhoto = (item) =>
  (item.photos || []).filter((p) => !p.is_deleted)[0];

export const allPhotos = (item) =>
  (item.photos || []).filter((p) => !p.is_deleted);

export const Thumb = ({
  item,
  testId,
  className = "h-40 rounded-md border border-zinc-800",
}) => {
  const p = firstPhoto(item);
  return p ? (
    <img
      src={photoSrc(p, true)}
      alt={item.slab_color || "Stone"}
      data-testid={testId}
      className={`w-full object-cover ${className}`}
    />
  ) : (
    <div
      data-testid={testId}
      className={`flex w-full items-center justify-center border-dashed bg-zinc-950 ${className}`}
    >
      <ImageSquare size={26} weight="bold" className="text-zinc-700" />
    </div>
  );
};
